import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {EndUserPricePlanModel} from '../end-user-price-plan-card/end-user-price-plan.model';
import {Observable} from 'rxjs';
import {Unit} from '../../dashboard/monitoring/unit';
import {environment} from '../../../environments/environment';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UnitPricePlansService {

  constructor(
    private http: HttpClient
  ) { }

  public getUnitPricePlans(unitId: number): Observable<Array<EndUserPricePlanModel>> {
    const httpParams = (new HttpParams()).append(
      'expand',
      [
        'endUserPricePlans.translatedName',
        'endUserPricePlans.translatedDescriptionSpeedMode',
        'endUserPricePlans.translatedDescriptionPrice',
        'endUserPricePlans.translatedDescriptionTitle1',
        'endUserPricePlans.translatedDescriptionTitle2',
        'endUserPricePlans.translatedDescriptionTitle3',
        'endUserPricePlans.translatedDescriptionTitle4',
        'endUserPricePlans.translatedDescriptionValue1',
        'endUserPricePlans.translatedDescriptionValue2',
        'endUserPricePlans.translatedDescriptionValue3',
        'endUserPricePlans.translatedDescriptionValue4',
      ].join(',')
    );

    return this.http.get<Unit>(
      environment.apiBasepoint + 'unit/' + unitId.toString(),
      {
        params: httpParams,
        observe: 'body'
      }
    ).pipe(
      map(
        unit => unit.endUserPricePlans
      )
    );
  }
}
